import GeoSelectOption from '@/common/components/GeoSelectOption'
import { formatCurrency, formatDecimal, formatUnit } from '@/common/utils/formatters'
import { UpdateContractProductCategoryValidationSchema } from '@/features/privateCompanies/schemas/contract/updateCreditLimits.schema'
import { CompanyContractType } from '@/features/privateCompanies/types/companyContract.type'
import { options as priceRuleOptions } from '@/features/publicCompanyLeadsFunnel/constants/priceRuleOptions.constant'

export const contractProductCategoriesDefaultValues: (props: {
  contractProductCategory: CompanyContractType['contract_product_categories'][number]
}) => UpdateContractProductCategoryValidationSchema = ({ contractProductCategory }) => ({
  id: contractProductCategory?.id,
  product_category: contractProductCategory?.product_category,
  global_value_in_currency: formatCurrency(Number(contractProductCategory?.global_value_in_currency) || 0),
  global_value_in_unit_for_consumption: formatUnit(
    formatDecimal(contractProductCategory?.global_value_in_unit_for_consumption || 0, 2),
    '',
  ),
  contract_product_category_products: contractProductCategory?.contract_product_category_products?.map(
    (productPrice) => ({
      id: productPrice.id,
      product: productPrice.product,
      price_rule: priceRuleOptions.find((option) => option.value === productPrice.price_rule),
      filterByRegion: productPrice.contract_product_category_product_prices?.some((price) => !!price.geo),
      global_value_in_currency: productPrice?.global_value_in_currency
        ? formatCurrency(Number(productPrice.global_value_in_currency) || 0)
        : '',
      global_value_in_unit_for_consumption: productPrice?.global_value_in_unit_for_consumption
        ? formatUnit(
            formatDecimal(
              productPrice.global_value_in_unit_for_consumption || 0,
              productPrice.product?.unit_for_quantity === 'item' ? 0 : 2,
            ),
            productPrice.product?.unit_for_quantity,
          )
        : '',
      contract_product_category_product_prices: productPrice.contract_product_category_product_prices?.map((price) => ({
        id: price.id,
        value: price.value ? formatCurrency(Number(price.value) || 0) : '',
        geo: price.geo
          ? {
              value: price.geo?.id,
              label: <GeoSelectOption geo={price.geo} />,
              type: 'Geo::City',
            }
          : undefined,
      })),
    }),
  ),
})
